<template>
    <div class="all-order ">
        <div class="all-order-content">
            <!-- <div style="padding: 20px;display: flex; justify-content: start;margin-left: 5%;" v-if="applicationRangesList.length>0||categoriesList.length>0">
                <div>
                    <p class="fontWig" style="font-size: 18px;">参展展品和服务</p>
                    <p v-for="(item1, index1)  in categoriesList" :key="index1"  style="margin-top: 10px;">
                        {{ item1.treeName }}</p>
               
                </div>
                <div style="margin-left: 30%;">
                    <p class="fontWig" style="font-size: 18px;">应用领域</p>
                    <p v-for="(item, index) in applicationRangesList" :key="index" style="margin-top: 10px;">
                        {{ item.treeName }}</p>
                </div>
            </div> -->
            <div v-show="applicationRangesList.length > 0 || categoriesList.length > 0" class="tree" style="width:79%">

                <el-row style="background-color: #fff;" :gutter="20">
                    <el-col :span="12">
                        <p style="color: #000;font-size: 16px;font-weight: 600;margin: 10px 0;">参展品类和服务</p>
                        <el-tree ref="tree1" :default-expand-all="true" :data="data" show-checkbox node-key="name"
                            :props="defaultProps">
                            <!-- <template v-slot="{ node, data }">
                                <span :class="{ 'is-disabled': node.disabled }">{{ data.name }}</span>
                            </template> -->
                        </el-tree>
                    </el-col>
                    <el-col :span="12">
                        <p style="color: #000;font-size: 16px;font-weight: 600;margin: 10px 0;">应用领域</p>
                        <el-tree ref="tree2" :default-expand-all="true" :data="data1" show-checkbox node-key="name"
                            :props="defaultProps">
                        </el-tree>
                    </el-col>

                </el-row>
            </div>
            <div class="" v-show="applicationRangesList.length <= 0 && categoriesList.length <= 0">
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>

                </el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "all-order",
    props: {
        timeValue: String
    },
    data () {
        return {
            list: [],
            applicationRangesList: [],
            categoriesList: [],
            descriptionsData: {},
            defaultProps: {
                children: 'childrens',
                label: 'name',
                disabled: this.disabledFn
            },
            data: [],
            data1: [],

        }
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },
        queryData () {
            let data = sessionStorage.getItem('sessData')
            return JSON.parse(data);
        },

    },
    mounted () {
        this.init()
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            getfreerecordList: 'exhibitionModule/getfreerecordList', //获取会刊免费登记记录
            getjournalfreerecord: 'exhibitionModule/getjournalfreerecord', //修改
            joinProductId: "hostSetModule/joinProductId",//获取参展品类和服务
            applicationrangeId: "hostSetModule/applicationrangeId",//获取应用领域
            exhibitorAsync: 'hostSetModule/exhibitorAsync', //修改
        }),
        disabledFn () {
                return true
        },

        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
        async init () {
            await this.getJoinProduct()
            await this.getapplicationrange()
            let res1 = await this.exhibitorAsync(this.queryId)
            if (res1) {
                this.applicationRangesList = res1.applicationRanges
                this.categoriesList = res1.categories

                let arr = []
                let arr1 = []
                this.applicationRangesList.forEach(item => {
                    arr.push({
                        name: item.name,
                    })
                })
                this.categoriesList.forEach(item => {
                    arr1.push({
                        name: item.name,
                    })
                })
                this.$refs.tree1.setCheckedNodes(arr1);
                this.$refs.tree2.setCheckedNodes(arr);
                console.log(this.$refs, 1231231231, arr, arr1);
            }


        },
        async getJoinProduct () {
            const res = await this.joinProductId()
            if (res && res.length) {
                // res.forEach(item=>{
                //     item.disabled=true
                //     if(item.childrens&&item.childrens.length){
                //     }
                // })
                this.data = res
                console.log(res, 'res');
            }
        },
        async getapplicationrange () {
            const res = await this.applicationrangeId()
            if (res && res.length) {

                this.data1 = res
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;

    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}
</style>